import { ADD_ROTATION_POSITION, ADD_ROTATION_POSITION_SUCCESS, ADD_ROTATION_POSITION_ERROR } from './actionTypes';

const initialState = {
  errorAddRotationPosition: '',
  loadingAddRotationPosition: false,
  successAddRotationPosition: '',
};

const addRotationPosition = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ROTATION_POSITION:
      state = {
        ...state,
        loadingAddRotationPosition: true,
      };
      break;
    case ADD_ROTATION_POSITION_SUCCESS:
      state = {
        ...state,
        loadingAddRotationPosition: false,
        successAddRotationPosition: action.payload.message,
      };
      break;
    case ADD_ROTATION_POSITION_ERROR:
      state = { ...state, errorAddRotationPosition: action.payload, loadingAddRotationPosition: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default addRotationPosition;
